import { render, staticRenderFns } from "./AppCarouselSsoItem.vue?vue&type=template&id=f18caf56"
import script from "./AppCarouselSsoItem.vue?vue&type=script&lang=js"
export * from "./AppCarouselSsoItem.vue?vue&type=script&lang=js"
import style0 from "./AppCarouselSsoItem.vue?vue&type=style&index=0&id=f18caf56&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports